import Box from './Box'
import Header from './Header'
import pageScrollContainer from './pageScrollContainer'
const KS_Compoents = {
  install(Vue){
    Vue.component('KsBox',Box)
    Vue.component('KsHeader',Header)
		Vue.component('KsPageScrollContainer',pageScrollContainer)
  }
}
export default KS_Compoents




// WEBPACK FOOTER //
// ./src/ks-components/index.js